<template>
  <tr>
    <td class="text-xs-left">
      <v-checkbox
        v-model="props.selected"
        hide-details
      />
    </td>
    <td>
      <router-link
        :to="{
          name: 'single_customer',
          params: { id: props.item.id }
        }"
      >
        {{ props.item.fullname }}
      </router-link>
    </td>
    <td class="text-xs-left">
      {{ props.item.email }}
    </td>
    <td class="text-xs-left">
      {{ props.item.dob }}
    </td>
    <td class="text-xs-left">
      {{ props.item.telephone | telephone }}
    </td>
    <td class="text-xs-left">
      {{ props.item.created_at | timezone }}
    </td>
  </tr>
</template>
<script>

export default {
  name: 'CustomerDataTableRow',

  props: {
    props: {
      type: Object,
      required: true
    }
  }
}
</script>
